<script setup lang="ts">
import { computed } from 'vue';
import { alignmentClasses, justificationClasses, type UiAlignment, type UiJustification } from '../ui-layout/classes';

type ActionGroupLayout = 'inline' | 'responsive' | 'stacked';

const props = withDefaults(defineProps<{
    layout?: ActionGroupLayout;
    animated?: boolean;
    align?: UiAlignment;
    justify?: UiJustification;
}>(), {
    layout: 'inline',
    animated: undefined,
    align: 'center',
    justify: 'start'
});

const headerPresence = inject('ideo-header-action-presence', false);
const animated = computed(() => props.animated ?? headerPresence);

const layoutClasses: Record<ActionGroupLayout, string> = {
    inline: 'inline-flex flex-wrap',
    responsive: 'flex w-auto flex-row flex-wrap max-sm:w-full max-sm:flex-col',
    stacked: 'flex flex-col'
};

const classes = computed(() => [
    'gap-2',
    layoutClasses[props.layout],
    alignmentClasses[props.align],
    justificationClasses[props.justify]
]);
</script>

<template>
    <IdeoActionPresence group :animated="animated" :class="classes" role="group">
        <slot name="default" />
    </IdeoActionPresence>
</template>
